// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"AddProspectClient_modalContainer__2MNeD","header":"AddProspectClient_header__QANmU","selector":"AddProspectClient_selector__iSY0x"};